import BaseBackdrop from '../backdrop/backdrop';
import CircularProgress from '../circular-progress/circular-progress';
import { styled } from '../styles/styles';

const Backdrop = styled(BaseBackdrop)`
  opacity: 0.5 !important;
  z-index: 9999;
`;

export const OverlayLoader = () => {
  return (
    <Backdrop
      className="sbv-overlay-loader"
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={true}
    >
      <CircularProgress />
    </Backdrop>
  );
};
